'use strict';

export default {
  init() {
    /*const resourceQuery = document.querySelector('#resource-query');

    if (resourceQuery) {
      resourceQuery.addEventListener('click', (event) => {
        event.preventDefault();

        const wrap = document.querySelector('.resource-search__wrapper');
        wrap.classList.toggle('open');
      });
    }*/

    const resourceFilter = document.querySelector('#resource-filter');

    if (resourceFilter) {
      resourceFilter.addEventListener('click', (event) => {
        event.preventDefault();

        const dropdown = document.querySelector('.dropdown');
        dropdown.classList.toggle('d-none');
      });
    }
  },
};
